import { createIcon } from "@chakra-ui/react";

const Megaphone = createIcon({
  path: (
    <path
      d="M18.1099 17.3802C19.2264 17.3802 20 16.5978 20 15.4901V1.89011C20 0.782418 19.2264 0 18.1099 0C17.011 0 16.2286 0.782418 16.2286 1.89011V15.4901C16.2286 16.5978 17.011 17.3802 18.1099 17.3802ZM6.82198 13.0022C9.34505 13.2835 12.4747 14.0484 14.989 15.2879C14.9802 15.1824 14.9802 15.0769 14.9802 14.9714V2.48791C14.9802 2.37363 14.9802 2.27692 14.989 2.16264C12.4923 3.39341 9.13407 4.2022 6.82198 4.45714V13.0022ZM3.77143 12.9934H5.55604V4.45714H3.77143C1.32747 4.45714 0 5.74066 0 8.0967V9.34505C0 11.7099 1.32747 12.9934 3.77143 12.9934ZM7.34066 19.0418C8.48352 19.0418 9.32747 18.2066 9.01978 16.8264L8.51868 14.5495C7.72747 14.4 6.61978 14.3033 4.36923 14.2505C4.21978 14.2505 3.96484 14.233 3.70989 14.233L5.25714 17.4769C5.72308 18.4703 6.27692 19.0418 7.34066 19.0418Z"
      fill="currentColor"
    />
  ),
  viewBox: "0 0 20 20",
});

export { Megaphone };
